'use client'

import type { PostHogConfig } from 'posthog-js'
import { Toaster } from '@/src/components/ui/sonner'
import { QueryClientProvider } from '@tanstack/react-query'
import { posthog } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { getQueryClient } from '../lib/config'

// Inicializar PostHog solo en el cliente
if (typeof window !== 'undefined') {
  // Acceder a las variables de entorno
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY
  const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST

  if (posthogKey) {
    // Definir la configuración con tipos correctos
    const config: Partial<PostHogConfig> = {
      api_host: posthogHost || undefined,
      person_profiles: 'identified_only' as const, // or 'always' to create profiles for anonymous users as well
    }

    posthog.init(posthogKey, config)
  }
}

export function Providers({ children }: { children: React.ReactNode }) {
  // Get the singleton QueryClient instance
  const queryClient = getQueryClient()

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <PostHogProvider client={posthog}>{children}</PostHogProvider>
      </QueryClientProvider>
      <Toaster />
    </>
  )
}
